import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Dashboard from '../screens/Dashboard.js';
import NotFound from '../screens/NotFound.js';
import { useAuth } from '../context/AuthProvider.js';
import SplashScreen from '../screens/SplashScreen.js';
import Settings from '../screens/Setting.js';
import Layout from '../components/Layout.js';
import ProductsListView from '../screens/ProductsListView.js';
import Fonts from '../screens/Fonts.js';
import Alerts from '../screens/Alerts.js';
import Troubleshooting from '../screens/Troubleshooting.js';
import ProductsDetailsView from '../screens/ProductDetailsView.js';
import Symbols from '../screens/Symbols.js';
import Gemstones from '../screens/Gemstones.js';
import Templates from '../screens/Templates.js';
import Migrations from '../screens/Migrations.js';

function AppNavigator() {
    const { loading } = useAuth();
    if ( loading ) {
        return <SplashScreen /> 
    }

    return(
        <Router>
            <Routes>
                <Route path="/" element={ <Layout/> } >
                    <Route index element={ <Dashboard/> } />
                    <Route path="products" element={ <ProductsListView/> } />
                    <Route path="products/:handle" element={ <ProductsDetailsView/>} />
                    <Route path="templates" element={ <Templates/> } />
                    <Route path="settings" element={ <Settings/> } />
                    <Route path="alerts" element={ <Alerts/> } />
                    <Route path="fonts" element={ <Fonts/> } />
                    <Route path="symbols" element={ <Symbols /> } />
                    <Route path="gemstones" element={ <Gemstones/> } />
                    <Route path="troubleshooting" element={ <Troubleshooting/> } />
                    <Route path="migrations" element={ <Migrations/> } />
                    <Route path="*" element={ <NotFound />} />
                </Route>
            </Routes>
        </Router>
    )
}

export default AppNavigator;